import styled, { ThemeProps } from 'styled-components';
import { Theme } from '../theme';
import { media } from '../theme/base/mixins';
import { StyledDivComponent } from '../types';

export const Divider: StyledDivComponent = styled.div`
  height: 1px;
  width: 100%;
  background: ${(props: ThemeProps<Theme>) => props.theme.colors.grayLight};
  margin-bottom: 60px;

  ${media.xlarge`
    margin-bottom: 80px;
  `}
`;
